<template>
    <section class="related-posts-wrapper pt-40px pb-50px">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1 class="section-title mb-30px" v-if="dlabData.blogData.relatedPost.title">
                        {{dlabData.blogData.relatedPost.title}}
                    </h1>
                </div>
            </div>
            <div class="row responsive-tablet-col-2 responsive-mobile-col-1">
                <div class="col-md-4" v-for="item in dlabData.blogData.relatedPost.items" :key="item.id">
                    <blog-item :item="item" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import dlabData from '@/store/store';
import BlogItem from '../../cards/BlogItem.vue';

export default {
    name: 'RelatedPosts',
    components: {
        BlogItem
    },
    data() {
        return {
            dlabData
        }
    }
}
</script>